import * as React from 'react';
import { useSelector } from 'react-redux';

import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { selectHasDiscountMortgage } from 'shared/selectors';

import { PromosBannerCallButton } from './PromosBannerCallButton';
import { PromosBanner as PromosBannerComponent } from '../../../components/NewbuildingPromos/parts/PromosBanner';

const DEFAULT_TEXT = `Узнайте про персональные условия и\u00A0дополнительные скидки при\u00A0покупке квартиры
      у\u00A0застройщика`;

export const PromosBanner = () => {
  const { config } = useApplicationContext();

  const discountMortgageText = config.getStrict<string>('Newbuilding.DiscountMortgageBanner.Text');
  const isDiscountMortgageEnabled = config.getStrict<boolean>('Newbuilding.DiscountMortgageBanner.Enabled');
  const hasDiscountMortgage = useSelector(selectHasDiscountMortgage);

  const text = isDiscountMortgageEnabled && hasDiscountMortgage ? discountMortgageText : DEFAULT_TEXT;

  return <PromosBannerComponent CallButton={PromosBannerCallButton} text={text} />;
};
